import React, { Fragment } from 'react';

const ContainerRight = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export default ContainerRight;



// WEBPACK FOOTER //
// ./src/components/layouts/containerRight/containerRight.js